import React from 'react';
import { PropTypes } from 'prop-types';
import Button from '../../../../../../components/Button';
import Text, { TextType } from '../../../../../../components/Text';

import './CtaButton.scss';

const CtaButton = ({ onClick, btnText, fluid }) => {
  const className = 'c-CtaButton';

  return (
    <div className={className}>
      <Button onClick={onClick} fluid={fluid}>
        <Text text={btnText} />
      </Button>
    </div>
  );
};

CtaButton.defaultProps = {
  fluid: false,
};

CtaButton.propTypes = {
  btnText: TextType,
  onClick: PropTypes.func,
  fluid: PropTypes.bool,
};

export default CtaButton;
